let cloudinaryIsScrolling;
const halfWindowHeight = window.outerHeight / 2;
const halfWindowWidth = window.outerWidth / 2;
const ResponsiveCloudinaryImages = class {
    constructor() {
        this.AddListeners();
        this.lastWidth = 0;
    }

    Run(scope) {
        Array.from(scope.querySelectorAll('[data-resource-processor="cloudinary"]')).filter(this.NotLoaded.bind(this)).filter(this.InView.bind(this)).filter(this.ElementIsVisible.bind(this)).forEach(this.ProcessImage.bind(this));
        this.lastWidth = window.innerWidth;
    }

    ProcessImage(image) {
        const source = image.dataset['src'];
        const height = image.clientHeight !== undefined && image.clientHeight !== null ? image.clientHeight : image.height;
        const width = image.clientWidth !== undefined && image.clientWidth !== null ? image.clientWidth : image.width;
        const cropPointX = image.hasAttribute('data-crop-point-x') && !!image.dataset.cropPointX ? image.dataset.cropPointX : null;
        const cropPointY = image.hasAttribute('data-crop-point-y') && !!image.dataset.cropPointY ? image.dataset.cropPointY : null;
        const imageHeight = image.hasAttribute('data-image-height') && !!image.dataset.imageHeight ? image.dataset.imageHeight : null;
        const imageWidth = image.hasAttribute('data-image-width') && !!image.dataset.imageWidth ? image.dataset.imageWidth : null;
        const autoHeight = image.hasAttribute('data-autoheight');
        const autoWidth = image.hasAttribute('data-autowidth');
        const resizeMode = !image.dataset.resizeMode ? "fit" : image.dataset.resizeMode.toLowerCase();
        let transformations = 'f_auto,q_auto';

        if (autoHeight !== true) {
            transformations += `,h_${height}`;
        }

        if (autoWidth !== true) {
            transformations += `,w_${width}`;
        }

        if ((!!cropPointX || !!cropPointY) && (resizeMode === "fill" || resizeMode === "crop")) {
            transformations += `,g_xy_center`;
        }

        if (!!cropPointX) {
            const transformed = (imageWidth * cropPointX).toFixed(0);
            const roundedUp = transformed >= 0 ? transformed : 0;
            transformations += `,x_${roundedUp}`;
        }

        if (!!cropPointY) {
            const transformed = (imageHeight * cropPointY).toFixed(0);
            const roundedUp = transformed >= 0 ? transformed : 0;
            transformations += `,y_${roundedUp}`;
        }

        transformations += `,c_${resizeMode}`;
        transformations += `/dpr_${this.GetDPR()}`;
        this.SplitUrlIntoParts(source).then(parts => `${parts.base}${transformations}/${parts.file}`).then(parsedUrl => this.AddUrlToElement(image, parsedUrl)).then(_ => this.AddSizesToElement(image, height, width))
            .then(_ => image.dataset['loaded'] = true)
            .then(_ => {
                const event = new Event("cloudinaryImageLoaded");
                image.dispatchEvent(event);
            });
    }

    AddSizesToElement(image, height, width) {
        image.setAttribute("height", height);
        image.setAttribute("width", width);
    }

    AddUrlToElement(image, url) {
        if (!!image.style.backgroundImage) {
            image.style.backgroundImage = `url('${url}')`;
        } else {
            image.setAttribute('src', url);
        }
    }

    GetDPR() {
        let dpr = (typeof window !== "undefined" && window !== null ? window.devicePixelRatio : void 0) || 1;

        if (dpr <= 0 || dpr === 0 / 0) {
            dpr = 1;
        }

        let dprString = dpr.toString();

        if (dprString.match(/^\d+$/)) {
            dprString += '.0';
        }

        return dprString;
    }

    InView(image) {
        const boundingClientRect = image.getBoundingClientRect();
        const elementTop = boundingClientRect.top - halfWindowHeight;
        const elementRight = boundingClientRect.right + halfWindowWidth;
        const elementLeft = boundingClientRect.left - halfWindowWidth;
        return elementTop <= window.innerHeight
            && elementLeft <= window.innerWidth
            && elementRight > 0;
    }

    ElementIsVisible(element) {
        if (element.offsetWidth === 0 || element.offsetHeight === 0) {
            return false;
        }

        const elementStyles = window.getComputedStyle(element);

        if (elementStyles.display === 'none') {
            return false;
        }

        if (elementStyles.opacity === '0') {
            return false;
        }

        if (element.parentElement === null) {
            return true;
        } else {
            return this.ElementIsVisible(element.parentElement);
        }
    }

    NotLoaded(image) {
        return image.dataset['loaded'] !== 'true';
    }

    async SplitUrlIntoParts(url) {
        const parts = url.match('(?<base>.*\/upload\/)(?<file>.*)');
        return {
            'base': parts.groups.base,
            'file': parts.groups.file
        };
    }

    ClearAll(container) {
        Array.from(container.querySelectorAll("[data-resource-processor=cloudinary][data-loaded=true]")).forEach(elm => this.ResetImage(elm));
    }

    ResetImage(image) {
        image.removeAttribute("src");
        image.removeAttribute("height");
        image.removeAttribute("width");
        image.removeAttribute("data-loaded");
    }

    ReRun(scope) {
        this.ClearAll(scope);
        this.Run(scope);
    }

    AddListeners() {
        this.AddVisibilityChange();
        this.AddResizeChange();
        this.AddScrollListener(window);
    }

    AddVisibilityChange() {
        document.addEventListener('visibilitychange', () => {
            if (document.hidden === false) {
                const checker = setInterval(() => {
                    if (window.outerHeight > 0) {
                        window.clearInterval(checker);
                        cloudinaryProcessor.ReRun(document);
                    }
                }, 10);
            }
        }, {
            once: true
        });
    }

    AddResizeChange() {
        window.addEventListener("resize", function () {
            const difference = window.innerWidth - cloudinaryProcessor.lastWidth;

            if (difference >= 200) {
                cloudinaryProcessor.ReRun(document);
            }
        });
    }

    AddScrollListener(element) {
        element.addEventListener("scroll", function () {
            window.clearTimeout(cloudinaryIsScrolling);
            cloudinaryIsScrolling = setTimeout(function () {
                cloudinaryProcessor.Run(document);
            }, 100);
        });
    }

};
const cloudinaryProcessor = new ResponsiveCloudinaryImages();
document.addEventListener("DOMContentLoaded", () => {
    cloudinaryProcessor.Run(document);
});